import PaymentScoreBadge from "./PaymentScoreBadge";

export default function RestaurantSideCard({ restaurant }) {
  return (
    <div className="ga-card p-6">
      <h3 className="font-display text-lg font-bold text-slate-900">Acquirente</h3>
      <div className="mt-2 text-sm text-slate-700">{restaurant?.name}</div>
      {restaurant?.id === null && <div className="mt-1 text-[11px] text-amber-800 bg-amber-50 border border-amber-200 rounded-lg px-2 py-1" data-testid="buyer-masked-notice">Identità e indirizzo esatto visibili solo al fornitore aggiudicatario.</div>}
      <div className="text-xs text-slate-500 mt-0.5">★ {restaurant?.rating_avg} ({restaurant?.rating_count} recensioni)</div>
      {restaurant?.payment_score && (
        <div className="mt-3 p-3 rounded-xl bg-slate-50 border border-slate-200" data-testid="restaurant-payment-score">
          <div className="text-xs font-mono uppercase tracking-widest text-slate-600 mb-2">Affidabilità pagamenti</div>
          <PaymentScoreBadge score={restaurant.payment_score} size="md" withDetails testId="restaurant-payment-score-badge" />
          {restaurant.payment_score.payment_rate != null && (
            <div className="mt-2 text-xs text-slate-600">
              Pagamenti a buon fine: <span className="font-mono font-bold">{Math.round(restaurant.payment_score.payment_rate * 100)}%</span>
              {restaurant.payment_score.avg_payment_hours != null && (
                <> · media <span className="font-mono font-bold">{restaurant.payment_score.avg_payment_hours}h</span> dall'aggiudicazione</>
              )}
            </div>
          )}
          {restaurant.payment_score.stars === 0 && (
            <div className="mt-2 text-xs text-slate-500">Poche transazioni per un punteggio affidabile.</div>
          )}
        </div>
      )}
    </div>
  );
}
